var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03104 3.00027L2.99988 4.03143L19.9688 21.0003L20.9999 19.9692L4.03104 3.00027Z",
    fill: "#9E9FA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1566 9.00421L14.9958 11.8434C14.9563 11.1032 14.6445 10.4037 14.1204 9.8796C13.5962 9.35545 12.8968 9.04365 12.1566 9.00421V9.00421Z",
    fill: "#9E9FA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8434 14.9958L9.00421 12.1566C9.04365 12.8968 9.35545 13.5962 9.8796 14.1204C10.4037 14.6445 11.1032 14.9563 11.8434 14.9958Z",
    fill: "#9E9FA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C11.3077 16.5 10.6248 16.3403 10.0043 16.0333C9.38376 15.7263 8.84246 15.2803 8.42248 14.73C8.00249 14.1796 7.71514 13.5398 7.58278 12.8603C7.45043 12.1808 7.47664 11.4799 7.65937 10.8122L4.42172 7.57404C3.09938 8.78529 1.83937 10.3659 0.75 12C1.98844 14.0625 3.6825 16.1831 5.44687 17.399C7.47094 18.7931 9.67172 19.5 11.9887 19.5C13.255 19.5009 14.5117 19.282 15.7031 18.8531L13.1902 16.3406C12.8024 16.4467 12.4021 16.5003 12 16.5V16.5Z",
    fill: "#9E9FA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C12.6923 7.49997 13.3752 7.65966 13.9957 7.96665C14.6162 8.27365 15.1575 8.71966 15.5775 9.27C15.9975 9.82034 16.2848 10.4602 16.4172 11.1397C16.5495 11.8192 16.5233 12.5201 16.3406 13.1878L19.6528 16.5C21.0192 15.2695 22.2811 13.6144 23.25 12C22.0134 9.96422 20.3015 7.84875 18.5072 6.61781C16.4578 5.2125 14.2645 4.5 11.9887 4.5C10.7364 4.5018 9.49465 4.72869 8.32263 5.16984L10.8122 7.65937C11.1992 7.55344 11.5987 7.49984 12 7.5V7.5Z",
    fill: "#9E9FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePass);
export default __webpack_public_path__ + "static/media/hide-pass.2a7174544d1358ae1160773587c297a0.svg";
export { ForwardRef as ReactComponent };